import * as React from 'react';
import propz from 'propz';
import { FunctionComponent } from 'react';
import { GENDER_SERVER_TO_CLIENT_MAPPING } from '../../consts/user';
import moment from 'moment';
import { DATE_FORMAT } from '../../consts/date';

interface Props {
  student: any;
  isUnionAdmin?: boolean;
}

export const ROWS = [
  { title: 'Name', field: 'firstName' },
  { title: 'Surname', field: 'lastName' },
  { title: 'Gender', field: 'gender' },
  { title: 'Date of birth', field: 'birthday' },
  { title: 'Form', field: 'formName' },
  { title: 'House', field: 'houseName' },
  { title: 'Medical information', field: 'medicalInfo' },
  { title: 'SEN', field: 'specialEducationNeeds' },
  { title: 'PP', field: 'pupilsPremium' },
  { title: 'FSM', field: 'freeSchoolMeals' },
  { title: 'Photo consent opt-out', field: 'photoConsentOptOut' }
];

export const ROWS_ESSENTIAL = [
  { title: 'Name', field: 'firstName' },
  { title: 'Surname', field: 'lastName' },
  { title: 'Gender', field: 'gender' },
  { title: 'Date of birth', field: 'birthday' },
  { title: 'Form', field: 'formName' }
];

export const StudentSummary: FunctionComponent<Props> = props => {
  const selectedRows = props.isUnionAdmin ? ROWS_ESSENTIAL : ROWS;

  const rows = selectedRows.map((row, index) => {
    let contentCell: React.ReactNode;
    const field = row.field;

    const student = props.student;

    switch (field) {
      case 'gender':
        contentCell = GENDER_SERVER_TO_CLIENT_MAPPING[student.gender];
        break;
      case 'formName':
        contentCell = propz.get(student, ['form', 'name'], '');
        break;
      case 'houseName':
        contentCell = propz.get(student, ['house', 'name'], '');
        break;
      case 'specialEducationNeeds':
      case 'pupilsPremium':
      case 'freeSchoolMeals':
      case 'photoConsentOptOut':
        contentCell = typeof student[row.field] === 'boolean'
          ? <span className={`student-summaryFlag ${student[row.field] ? 'is-yes' : 'is-no'}`}>{student[row.field] ? 'Yes' : 'No'}</span>
          : <span className="student-summaryFlag is-unknown">—</span>;
        break;
      case 'birthday':
        contentCell = student[row.field] ? moment(student[row.field]).format(DATE_FORMAT) : '';
        break;
      default:
        contentCell = student[row.field] || (field === 'medicalInfo' ? 'None recorded' : '—');
    }

    return (
      <tr key={`student_summary_${index}`}>
        <td>{row.title}</td>
        <td>{contentCell}</td>
      </tr>
    );
  });

  return (
    <table className={'table table-sm mPre'}>
      <tbody>{rows}</tbody>
    </table>
  );
};

StudentSummary.displayName = 'StudentSummary';



